import { Box, Grid, IconButton, Typography, styled } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { color } from 'config/color'

interface IItem {
  Icon: any
  title: string
  route: string
}

export const Item = ({ title, Icon, route }: IItem): JSX.Element => {
  const navigate = useNavigate()


  return (
    <Grid item xs={12} sm={12} md={3} xl={3} mb={2}>
      <Wrapper onClick={() => { navigate(route) }} border={`solid 1px ${color.secondary.dark[300]}`} >
        <IconButton sx={{ background: color.secondary.dark[50], borderRadius: '2px' }}>
          <Icon sx={{ color: color.primary[600] }} />
        </IconButton>
        <Typography ml={1} color={color.grey[900]} fontSize={16}>{title}</Typography>
      </Wrapper>
    </Grid>
  )
}
const Wrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  background: color.white,
  borderRadius: 4,
  padding: '8px 16px 8px 8px',
  '&:hover': {
    cursor: 'pointer'
  }
})
